import md5 from 'js-md5'
import axios from 'axios'

// 默认配置
const initConfig = {
  buriedPointKey: '69d4e73c9a1d0f16fe0aede0ea076805',
  productLine: '跨境',
  childProductLine: '',
  defaultModName: '',
  sendType: 'time',
  sendDur: 1000,
  getUserInfo() {
    const fullname = JSON.parse(localStorage.getItem('wangdian__store__fullname'))?.value
    const employeeId = JSON.parse(localStorage.getItem('wangdian__store__employeeId'))?.value
    const sid = JSON.parse(localStorage.getItem('wangdian__store__sid'))?.value
    return {
      sid, // 卖家账号
      userId: employeeId, // 登录用户id
      userName: fullname // 登录用户名
    }
  }
}

/**
 *  转换埋点数据结构
 * @param {String} buttonName   按钮名称
 * @param {String} viewName   页面名称
 * @param {String} moduleName  模块名称
 * @returns
 */
function getUserInfoList(buttonName, viewName, moduleName) {
  const { userName, userId } = initConfig.getUserInfo()
  const userInfo = [
    {
      user_name: userName,
      user_id: userId,
      version: '',
      mod_info: [
        {
          mod_name: moduleName,
          view_info: [
            {
              view_name: viewName,
              button_info: [
                {
                  button_name: buttonName,
                  click_num: 1
                }
              ]
            }
          ]
        }
      ]
    }
  ]
  return userInfo
}

/**
 *  发送埋点数据
 * @param {String} info 埋点具体数据   例：JSON.stringify({button:"按钮名称",type:"button_click"})
 * @param {String} viewName  页面名称
 * @param {String} moduleName 模块名称
 * @returns
 */
export async function sendRecordBuriedPoint(info, viewName, moduleName = '') {
  const time = Date.now()
  const { productLine, childProductLine, buriedPointKey, getUserInfo } = initConfig
  const { sid } = getUserInfo()
  const data = {
    time,
    product_line: productLine,
    sid,
    child_product_line: childProductLine,
    sign: md5(`${time}${initConfig.productLine}${sid}${childProductLine}${buriedPointKey}`),
    user_info: getUserInfoList(info, viewName, moduleName)
  }
  return axios.post('https://hawkapi.wangdian.cn/docking/buriedPoint', data)
}

/**
 * 初始化埋点
 * @param {*} config
 */
const initBurialOoint = (config = {}) => {
  Object.assign(initConfig, config)
}

export default initBurialOoint
